
// import React, { useState } from 'react';
// import { useNavigate } from "react-router-dom";
// import mechImage from '../img/aaaservices/TOOL & FIXTURE V1.jpg';
// import itImage from '../img/aaaservices/PYTHON V1.jpg';
// import digitalImage from '../img/aaaservices/DIGITAL FACILITY SIMULATIONS V3.jpg';

// import mechImg from '../img/aaaservices/VR.webp';
// import simImg from '../img/aaaservices/slashco-bridle1-2.jpg';
// import itImg from '../img/aaaservices/Java-Full-Stack-1-600x367.jpg';
// import itImg1 from '../img/aaaservices/PY.jpg';
// import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';
// import dfsImg from '../img/aaaservices/F.png';
// import dfsImg1 from '../img/aaaservices/Thumbnail-Skill-Based-Professions-1.png';
// import dfsImg2 from '../img/aaaservices/s.png';
// import dfsImg3 from '../img/aaaservices/d.webp';

// const styles = {
//   container: {
//     position: 'relative',
//     width: '100%',
//     maxWidth: '600px',
//     padding: '50px 0',
//     margin: 'auto',
//   },
//   labelContainer: {
//     position: 'absolute',
//     top: 37,
//     transform: 'translateX(-50%)',
//     zIndex: 2,
//   },
//   pin: {
//     // backgroundColor: 'orange',
//     color: '#fff',
//     padding: '5px 10px',
//     borderRadius: '50% 50% 50% 0',
//     transform: 'rotate(-45deg)',
//     width: '40px',
//     height: '40px',
//     textAlign: 'center',
//     lineHeight: '30px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     marginTop:'265px',
//     marginLeft:'56px'
//   },
//   pinText: {
//     transform: 'rotate(45deg)',
//     fontWeight: 'bold',
//     color: '#1f78ff',
//   },
//   slider: {
//     width: '100%',
//     height: '8px',
//     borderRadius: '4px',
//     background: '#e4e4ee',
//     appearance: 'none',
//     outline: 'none',
//     position: 'relative',
//     zIndex: 1,
//      marginTop:'36px'
    
//   }
// };

// const cardData = {
//   Mechanical: [
//     { id: 1, title: "Virtual Robotics", subtitle: "Simulated Automation", date: "2025-06-01", time: "10:00 AM - 4:00 PM", cost: "₹150", image: mechImg, link: "/Virtualpage" },
//     { id: 2, title: "Tool & fixture design",
//       name: "Jane Smith",
//       subtitle: "3D Product Design",
//       date: "2025-06-05",
//       time: "11:00 AM - 5:00 PM",
//       cost: "₹120",
//       image: simImg ,
//       link: "/fixture", },

//     { id: 3,  title: "Digital Factory",
//       name: "Mike Johnson",
//       subtitle: "Smart Production",
//       date: "2025-06-10",
//       time: "9:00 AM - 3:00 PM",
//       cost: "₹180",
//       image: dfsImg,
//       link: "/DigitalC",
//     },
//     // { id: 4, title: "Mech Card 4", subtitle: "Subtitle 4", date: "May 23", time: "3:00 PM", cost: "₹120", image: mechImage },
//     // { id: 5, title: "Mech Card 5", subtitle: "Subtitle 5", date: "May 24", time: "2:00 PM", cost: "₹95", image: mechImage },
//     // { id: 6, title: "Mech Card 6", subtitle: "Subtitle 6", date: "May 25", time: "1:00 PM", cost: "₹130", image: mechImage }
//   ],
//   IT: [
//     { id: 1, title: "Java Full-Stack-Devlopers",
//      subtitle: "Subtitle 2",
//       date: "2025-06-17",
//       time: "1:00 PM - 6:00 PM",
//       cost: "₹350",
//       image: itImg,
//       link: "/it-services",
//     }, 
//     { id: 2, title: "Python Full-Stack-Devlopers",
//      subtitle: "Subtitle 2",
//       date: "2025-06-19",
//       time: "10:00 AM - 2:00 PM",
//       cost: "₹300",
//       image: itImg1,
//       link: "/Puthonpage", },

//     { id: 3, title: "React & Flutter-Devlopers",
//     subtitle: "Subtitle 2",
//       date: "2025-06-19",
//       time: "10:00 AM - 2:00 PM",
//       cost: "₹300",
//       image: itImg2,
//       link: "/Reactpage", },

//     // { id: 4, title: "IT Card 4", subtitle: "Subtitle 4", date: "May 23", time: "3:00 PM", cost: "₹120", image: itImage },
//     // { id: 5, title: "IT Card 5", subtitle: "Subtitle 5", date: "May 24", time: "2:00 PM", cost: "₹95", image: itImage },
//     // { id: 6, title: "IT Card 6", subtitle: "Subtitle 6", date: "May 25", time: "1:00 PM", cost: "₹130", image: itImage }
//   ],
//   Digital: [
//     { id: 1, title: "Career foundation Skills",
//       subtitle: "Subtitle 2",
//       date: "2025-06-21",
//       time: "10:00 AM - 4:00 PM",
//       cost: "₹400",
//       image:  dfsImg1,
//       link: "/Outdoor", },

//     { id: 2, title: "Soft Skill Enhancements",
//      subtitle: "Subtitle 2",
//       date: "2025-06-22",
//       time: "9:00 AM - 1:00 PM",
//       cost: "₹450",
//       image: dfsImg2,
//       link: "/Sopftskillpage", },
//     { id: 3, title: "Digital Presence Skills",
//      subtitle: "Subtitle 2",
//       date: "2025-06-22",
//       time: "9:00 AM - 1:00 PM",
//       cost: "₹450",
//       image: dfsImg3 ,
//       link: "/Digitalpresenceskillpage", },
//     // { id: 4, title: "Digital Card 4", subtitle: "Subtitle 4", date: "May 23", time: "3:00 PM", cost: "₹120", image: digitalImage },
//     // { id: 5, title: "Digital Card 5", subtitle: "Subtitle 5", date: "May 24", time: "2:00 PM", cost: "₹95", image: digitalImage },
//     // { id: 6, title: "Digital Card 6", subtitle: "Subtitle 6", date: "May 25", time: "1:00 PM", cost: "₹130", image: digitalImage }
//   ]
// };

// const BranchFilterComponent = () => {
//   const [selectedBranch, setSelectedBranch] = useState('All');
//   const [dateFilter, setDateFilter] = useState("");
//   const [calendarDate, setCalendarDate] = useState("");
//   const [location, setLocation] = useState("");
//   const [language, setLanguage] = useState("");
//    const [price, setPrice] = useState(99);
//   const navigate = useNavigate();

//   const getFilteredData = () => {
//     let data = selectedBranch === 'All'
//       ? [...cardData.Mechanical, ...cardData.IT, ...cardData.Digital]
//       : cardData[selectedBranch] || [];

//     return data; // Add more filters here if needed later
//   };

//   return (
//     <div className="filter-container">
//       <div className="sidebar">
//         <h3 style={{fontFamily:'roboto',fontSize:'35px',margin:'-1px'}}>Filter</h3>
//         <select onChange={(e) => setSelectedBranch(e.target.value)} value={selectedBranch}>
//           <option value="All">All</option>
//           <option value="Mechanical">Mechanical</option>
//           <option value="IT">IT</option>
//           <option value="Digital">JOSE</option>
//         </select>

//         <select value={dateFilter} onChange={(e) => setDateFilter(e.target.value)}>
//           <option value="">Date</option>
//           <option value="today">Today</option>
//           <option value="tomorrow">Tomorrow</option>
//           <option value="weekend">This Weekend</option>
//         </select>

//         <input type="date" value={calendarDate} onChange={(e) => setCalendarDate(e.target.value)} />

//         <select value={location} onChange={(e) => setLocation(e.target.value)}>
//           <option value="">Location</option>
//           <option value="hyderabad">Hyderabad</option>
//           <option value="bangalore">Bangalore</option>
//           <option value="chennai">Chennai</option>
//           <option value="mumbai">Mumbai</option>
//         </select>

//         <select value={language} onChange={(e) => setLanguage(e.target.value)}>
//           <option value="">Language</option>
//           <option value="english">English</option>
//           <option value="hindi">Hindi</option>
//           <option value="telugu">Telugu</option>
//           <option value="tamil">Tamil</option>
//         </select>

//          <div style={{ ...styles.labelContainer, left: `${(price - 99) / (60000 - 99) * 100}%` }}>
//         <div style={styles.pin}>
//           <span style={styles.pinText}>₹{price}</span>
//         </div>
//       </div>
//       <input
//         type="range"
//         min={99}
//         max={60000}
//         step={1}
//         value={price}
//         onChange={(e) => setPrice(Number(e.target.value))}
//         style={styles.slider}
//       />
//       </div>
    

//       <div className="card-section">
//         {getFilteredData().map((card) => (
//           <div className="card" key={card.id} onClick={() => navigate(card.link || "#")}>
//             <img src={card.image} alt={card.title} />
//             <div className="card-content">
//               <p style={{fontSize:'20px',color:'blue',fontFamily:'roboto',}}>{card.title}</p>
//               <p>{card.subtitle}</p>
//               <p>{card.date} | {card.time}</p>
//               <p>{card.cost}</p>
//             </div>
//           </div>
//         ))}
//       </div>

//       <style jsx>{`
//         .filter-container {
//           display: flex;
//           gap: 20px;
//           padding: 20px;
//           font-family: Arial, sans-serif;
//         }

//         .sidebar {
//           min-width: 260px;
//           position: sticky;
//           max-width:320px;
//           top: 172px;
//           background: #f9f9f9;
//           padding: 15px;
//           border-radius: 8px;
//           box-shadow: 0 0 10px rgba(0,0,0,0.1);
//           height: fit-content;
//         }

//         .sidebar h3 {
//           margin-bottom: 10px;
//           font-size: 20px;
//           color: #333;
//         }

//         .sidebar select,
//         .sidebar input[type="date"] {
//           width: 100%;
//           padding: 8px;
//           margin-bottom: 15px;
//           font-size: 15px;
//           border-radius: 5px;
//           border: 1px solid #ccc;
//         }

//         .card-section {
//           flex: 1;
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 20px;
//         }

//         .card {
//           background: #fff;
//           border-radius: 10px;
//           border: 1px solid #ddd;
//           overflow: hidden;
//           cursor: pointer;
//           transition: transform 0.2s ease;
//         }

//         .card:hover {
//           transform: translateY(-5px);
//         }

//         .card img {
//           width: 100%;
//           height: 160px;
//           object-fit: cover;
//           padding:10px;
//           border-radius:20px;
//         }

//         .card-content {
//           padding: 8px 15px;
//           text-align: left;
//         }

//         .card-content h2 {
//           font-size: 20px;
//           font-weight: bold;
//           color: blue;
//         }

//         .card-content p {
        
//           color: black;
//         font-weight: bold;
         
//           font-family:math;
//           text-align:left;
//         }

//         @media (max-width: 992px) {
//           .card-section {
//             grid-template-columns: repeat(2, 1fr);
//           }
//         }

//         @media (max-width: 600px) {
//           .filter-container {
//             flex-direction: column;
//           }

//           .sidebar {
//             width: 100%;
//             position: relative;
//             top: auto;
//           }

//           .card-section {
//             grid-template-columns: 1fr;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default BranchFilterComponent;




// import React, { useState } from 'react';
// // import React, { useState } from 'react';
// import { useNavigate } from "react-router-dom";
// // import mechImage from '../img/aaaservices/TOOL & FIXTURE V1.jpg';
// // import itImage from '../img/aaaservices/PYTHON V1.jpg';
// // import digitalImage from '../img/aaaservices/DIGITAL FACILITY SIMULATIONS V3.jpg';

// import mechImg from '../img/aaaservices/VR.webp';
// import simImg from '../img/aaaservices/slashco-bridle1-2.jpg';
// import itImg from '../img/aaaservices/Java-Full-Stack-1-600x367.jpg';
// import itImg1 from '../img/aaaservices/PY.jpg';
// import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';
// import dfsImg from '../img/aaaservices/F.png';
// import dfsImg1 from '../img/aaaservices/Thumbnail-Skill-Based-Professions-1.png';
// import dfsImg2 from '../img/aaaservices/s.png';
// import dfsImg3 from '../img/aaaservices/d.webp';
// import OnlyButtonrange from './OnlyButtonrange';
// import Advertisment from './Advertisment';

// const cardData = {
//   Mechanical: [
//     { id: 1, title: "Virtual Robotics", subtitle: "Simulated Automation", date: "2025-06-01", time: "10:00 AM - 4:00 PM", cost: "₹150", minPrice: 150, maxPrice: 150, location: "hyderabad", language: "english", image: mechImg, link: "/Virtualpage" },
//     { id: 2, title: "Tool & Fixture Design", subtitle: "3D Product Design", date: "2025-06-05", time: "11:00 AM - 5:00 PM", cost: "₹120", minPrice: 100, maxPrice: 200, location: "bangalore", language: "hindi", image: simImg, link: "/fixture" },
//     { id: 3, title: "Digital Factory", subtitle: "Smart Production", date: "2025-06-10", time: "9:00 AM - 3:00 PM", cost: "₹180", minPrice: 150, maxPrice: 250, location: "chennai", language: "telugu", image: dfsImg, link: "/DigitalC" },
//   ],
//   IT: [
//     { id: 4, title: "Java Full-Stack Developers", subtitle: "Complete Stack", date: "2025-06-17", time: "1:00 PM - 6:00 PM", cost: "₹350", minPrice: 300, maxPrice: 400, location: "hyderabad", language: "english", image: itImg, link: "/it-services" },
//     { id: 5, title: "Python Full-Stack Developers", subtitle: "Complete Stack", date: "2025-06-19", time: "10:00 AM - 2:00 PM", cost: "₹300", minPrice: 250, maxPrice: 350, location: "mumbai", language: "english", image: itImg1, link: "/Puthonpage" },
//     { id: 6, title: "Flutter Developers", subtitle: "Cross-Platform Apps", date: "2025-06-19", time: "10:00 AM - 2:00 PM", cost: "₹300", minPrice: 250, maxPrice: 350, location: "bangalore", language: "tamil", image: itImg2, link: "/Reactpage" },
//   ],
//   Digital: [
//     { id: 7, title: "Career Foundation Skills", subtitle: "Professional Basics", date: "2025-06-21", time: "10:00 AM - 4:00 PM", cost: "₹400", minPrice: 400, maxPrice: 500, location: "chennai", language: "telugu", image: dfsImg1, link: "/Outdoor" },
//     { id: 8, title: "Soft Skill Enhancements", subtitle: "Communication Mastery", date: "2025-06-22", time: "9:00 AM - 1:00 PM", cost: "₹450", minPrice: 400, maxPrice: 500, location: "hyderabad", language: "english", image: dfsImg2, link: "/Sopftskillpage" },
//     { id: 9, title: "Digital Presence Skills", subtitle: "Online Branding", date: "2025-06-22", time: "9:00 AM - 1:00 PM", cost: "₹450", minPrice: 400, maxPrice: 500, location: "mumbai", language: "hindi", image: dfsImg3, link: "/Digitalpresenceskillpage" },
//   ]
// };

// const BranchFilterComponent = () => {
//   const navigate = useNavigate();

//   const [selectedBranch, setSelectedBranch] = useState('All');
//   const [calendarDate, setCalendarDate] = useState('');
//   const [location, setLocation] = useState('');
//   const [language, setLanguage] = useState('');
//   const [minPrice, setMinPrice] = useState('');
//   const [maxPrice, setMaxPrice] = useState('');

//   const getFilteredData = () => {
//     let data = selectedBranch === 'All'
//       ? [...cardData.Mechanical, ...cardData.IT, ...cardData.Digital]
//       : cardData[selectedBranch] || [];

//     if (calendarDate) {
//       data = data.filter(card => card.date === calendarDate);
//     }

//     if (location) {
//       data = data.filter(card => card.location === location);
//     }

//     if (language) {
//       data = data.filter(card => card.language === language);
//     }

//     if (minPrice !== '') {
//       data = data.filter(card => card.minPrice >= parseInt(minPrice));
//     }

//     if (maxPrice !== '') {
//       data = data.filter(card => card.maxPrice <= parseInt(maxPrice));
//     }

//     return data;
//   };

//   return (
//     <div className="filter-container">
//       <div className="sidebar">
//         <h3 style={{fontFamily:'sans-serif',fontSize:'20px',color:'blue',marginTop:'2px'}}>Filters</h3>

//         <select value={selectedBranch} onChange={(e) => setSelectedBranch(e.target.value)}>
//           <option value="All">All Branches</option>
//           <option value="Mechanical">Mechanical</option>
//           <option value="IT">IT</option>
//           <option value="Digital">Jose</option>
//         </select>

//         <input type="date" value={calendarDate} onChange={(e) => setCalendarDate(e.target.value)} />

//         <select value={location} onChange={(e) => setLocation(e.target.value)}>
//           <option value="">Location</option>
//           <option value="hyderabad">Hyderabad</option>
//           <option value="bangalore">Bangalore</option>
//           <option value="chennai">Chennai</option>
//           <option value="mumbai">Mumbai</option>
//         </select>

//         <select value={language} onChange={(e) => setLanguage(e.target.value)}>
//           <option value="">Language</option>
//           <option value="english">English</option>
//           <option value="hindi">Hindi</option>
//           <option value="telugu">Telugu</option>
//           <option value="tamil">Tamil</option>
//         </select>

//         <select value={minPrice} onChange={(e) => setMinPrice(e.target.value)}>
//           <option value="">Min Price</option>
//           <option value="100">100</option>
//           <option value="200">200</option>
//           <option value="300">300</option>
//           <option value="400">400</option>
//         </select>

//         <select value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)}>
//           <option value="">Max Price</option>
//           <option value="300">300</option>
//           <option value="400">400</option>
//           <option value="500">500</option>
//         </select>
//       </div>

//       <div className="card-section">
//         {getFilteredData().map((card) => (
//           <div className="card" key={card.id} onClick={() => navigate(card.link)}>
//             <img src={card.image} alt={card.title} />
//             <div className="card-content">
//               <p style={{ fontSize: '20px', color: 'blue', fontFamily: 'roboto' }}>{card.title}</p>
//               <p>{card.subtitle}</p>
//               <p>{card.date} | {card.time}</p>
//               <p>{card.cost}</p>
//              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//   <p style={{ marginRight: '10px' }}>{card.location}, {card.language}</p>
//   <button style={{ 
//     borderRadius: '10px', 
//     backgroundColor: 'blue', 
//     color: 'white',
//     padding: '5px 15px',
//     border: 'none',
//     cursor: 'pointer'
//   }}>
//     Know More
//   </button>
// </div>

//             </div>
//           </div>
//         ))}
//       </div>

// <Advertisment />
//       <style jsx>{`
//         .filter-container {
//           display: flex;
//           gap: 20px;
//           padding: 20px;
          
//         }

//         .sidebar {
//            min-width: 260px;
//            position: sticky;
//            max-width:320px;
//            top: 172px;
//            background: #f9f9f9;
//           padding: 15px;
//            border-radius: 8px;
//            box-shadow: 0 0 10px rgba(0,0,0,0.1);
//            height: fit-content;
//          }

//         .sidebar select,
//         .sidebar input[type="date"] {
//           width: 100%;
//           padding: 8px;
//           margin-bottom: 15px;
//           font-size: 15px;
//           border-radius: 5px;
//           border: 1px solid #ccc;
//         }

//         .card-section {
//           flex: 1;
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 20px;
//         }

//         .card {
//           background: #fff;
//           border-radius: 10px;
//           border: 1px solid #ddd;
//           height:347px;
//           color:black;
//           overflow: hidden;
//           cursor: pointer;
//           transition: transform 0.2s ease;
//         }

//         .card:hover {
//           transform: translateY(-5px);
//         }

//         .card img {
//           width: 100%;
//           height: 160px;
//           object-fit: cover;
//           padding: 10px;
//           border-radius: 20px;
//         }

//         .card-content {
//           padding: 10px;
//         }

//         .card-content p {
//           margin: 5px 0;
//           font-family: math;
//           color:black
//         }

//         @media (max-width: 992px) {
//           .card-section {
//             grid-template-columns: repeat(2, 1fr);
//           }
//         }

//         @media (max-width: 600px) {
//           .filter-container {
//             flex-direction: column;
//           }

//           .sidebar {
//              width: 98%;
//              position: relative;
//              top: auto;
//            }


// @media (max-width: 480px) {
//           .filter-container {
//             flex-direction: column;
//           }

//           .sidebar {
//              width: 98%;
//              position: relative;
//              top: auto;
//            }


//              .card{
//              width:98%;
//              }

//           .card-section {
//             grid-template-columns: 1fr;
//           }
//         }
//       `}</style>

//       <div style={{marginTop:'-314px',left:'-2px'}}>
//       <OnlyButtonrange />
//       </div>
    
//     </div>
//   );
// };

// export default BranchFilterComponent;

// import React, { useState } from 'react';
// import { useNavigate } from "react-router-dom";
// import mechImage from '../img/aaaservices/TOOL & FIXTURE V1.jpg';
// import itImage from '../img/aaaservices/PYTHON V1.jpg';
// import digitalImage from '../img/aaaservices/DIGITAL FACILITY SIMULATIONS V3.jpg';

// import mechImg from '../img/aaaservices/VR.webp';
// import simImg from '../img/aaaservices/slashco-bridle1-2.jpg';
// import itImg from '../img/aaaservices/Java-Full-Stack-1-600x367.jpg';
// import itImg1 from '../img/aaaservices/PY.jpg';
// import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';
// import dfsImg from '../img/aaaservices/F.png';
// import dfsImg1 from '../img/aaaservices/Thumbnail-Skill-Based-Professions-1.png';
// import dfsImg2 from '../img/aaaservices/s.png';
// import dfsImg3 from '../img/aaaservices/d.webp';
// import OnlyButtonrange from './OnlyButtonrange';
// import Advertisment from './Advertisment';

// const cardData = {
//   Mechanical: [
//     { id: 1, title: "Virtual Robotics", subtitle: "Simulated Automation", date: "2025-06-01", time: "10:00 AM - 4:00 PM", cost: "₹70,000", minPrice: 70000, maxPrice: 70000, duration: "3 Months", location: "hyderabad", language: "english,", image: mechImg, link: "/Virtualpage" },
//     { id: 2, title: "Tool & Fixture Design", subtitle: "3D Product Design", date: "2025-06-05", time: "11:00 AM - 5:00 PM", cost: "₹70,000", minPrice: 70000, maxPrice: 70000, duration: "3 Months", location: "hyderabad", language: "english,", image: simImg, link: "/fixture" },
//     { id: 3, title: "Digital Factory", subtitle: "Smart Production", date: "2025-06-10", time: "9:00 AM - 3:00 PM", cost: "₹70,000", minPrice: 70000, maxPrice: 70000, duration: "3 Months", location: "hyderabad", language: "english,", image: dfsImg, link: "/DigitalC" },
//   ],
//   IT: [
//     { id: 4, title: "Java Full-Stack Developers", subtitle: "Complete Stack", date: "2025-06-17", time: "1:00 PM - 6:00 PM", cost: "₹70,000", minPrice: 70000, maxPrice: 70000, duration: "3 Months", location: "hyderabad", language: "english, ", image: itImg, link: "/it-services" },
//     { id: 5, title: "Python Full-Stack Developers", subtitle: "Complete Stack", date: "2025-06-19", time: "10:00 AM - 2:00 PM", cost: "₹70,000", minPrice: 70000, maxPrice: 70000, duration: "3 Months", location: "hyderabad", language: "english, ", image: itImg1, link: "/Puthonpage" },
//     { id: 6, title: "Flutter Developers", subtitle: "Cross-Platform Apps", date: "2025-06-19", time: "10:00 AM - 2:00 PM", cost: "₹70,000", minPrice: 70000, maxPrice: 70000, duration: "3 Months", location: "hyderabad", language: "english, ", image: itImg2, link: "/Reactpage" },
//   ],
//   Digital: [
//     { id: 7, title: "Career Foundation Skills", subtitle: "Professional Basics", date: "2025-06-21", time: "10:00 AM - 4:00 PM", cost: "₹70,000", minPrice: 70000, maxPrice: 70000, duration: "3 Months", location: "hyderabad", language: "english, ", image: dfsImg1, link: "/Outdoor" },
//     { id: 8, title: "Soft Skill Enhancements", subtitle: "Communication Mastery", date: "2025-06-22", time: "9:00 AM - 1:00 PM", cost: "₹70,000", minPrice: 70000, maxPrice: 70000, duration: "3 Months", location: "hyderabad", language: "english, ", image: dfsImg2, link: "/Sopftskillpage" },
//     { id: 9, title: "Digital Presence Skills", subtitle: "Online Branding", date: "2025-06-22", time: "9:00 AM - 1:00 PM", cost: "₹70,000", minPrice: 70000, maxPrice: 70000, duration: "3 Months", location: "hyderabad", language: "english, ", image: dfsImg3, link: "/Digitalpresenceskillpage" },
//   ]
// };


// const BranchFilterComponent = () => {
//   const navigate = useNavigate();

//   const [selectedBranch, setSelectedBranch] = useState("All");
//   const [calendarDate, setCalendarDate] = useState("");
//   const [location, setLocation] = useState("");
//   const [language, setLanguage] = useState("");
//   const [minPrice, setMinPrice] = useState("");
//   const [maxPrice, setMaxPrice] = useState("");

//   const getFilteredData = () => {
//     let data =
//       selectedBranch === "All"
//         ? [...cardData.Mechanical, ...cardData.IT, ...cardData.Digital]
//         : cardData[selectedBranch] || [];

//     if (calendarDate) {
//       data = data.filter((card) => card.date === calendarDate);
//     }

//     if (location) {
//       data = data.filter((card) => card.location === location);
//     }

//     // language contains logic
//     if (language) {
//       data = data.filter((card) =>
//         card.language.toLowerCase().includes(language.toLowerCase())
//       );
//     }

//     // price range filter
//     if (minPrice !== "" || maxPrice !== "") {
//       const min = minPrice ? parseInt(minPrice) : 0;
//       const max = maxPrice ? parseInt(maxPrice) : Infinity;

//       data = data.filter((card) => {
//         const price = card.minPrice;
//         return price >= min && price <= max;
//       });
//     }

//     return data;
//   };

//   return (
//     <div className="filter-container">
//       {/* Sidebar */}
//       <div className="sidebar">
//         <h3 className="filter-title">Filters</h3>

//         <select
//           value={selectedBranch}
//           onChange={(e) => setSelectedBranch(e.target.value)}
//         >
//           <option value="All">All Branches</option>
//           <option value="Mechanical">Mechanical</option>
//           <option value="IT">IT</option>
//           <option value="Digital">Digital</option>
//         </select>

//         <select value={location} onChange={(e) => setLocation(e.target.value)}>
//           <option value="">Location</option>
//           <option value="hyderabad">Hyderabad</option>
//         </select>

//         <select value={language} onChange={(e) => setLanguage(e.target.value)}>
//           <option value="">Language</option>
//           <option value="english">English</option>
//           {/* <option value="telugu">Telugu</option> */}
//         </select>

//         {/* <select value={minPrice} onChange={(e) => setMinPrice(e.target.value)}>
//           <option value="">Min Price</option>
//           <option value="30000">30,000</option>
//         </select> */}

//         <select value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)}>
//           <option value="">Max Price</option>
//           <option value="70000">70,000</option>
//         </select>
//         <select value="3 Months" disabled>
//           <option value="3 Months">Duration: 3 Months</option>
//         </select>
//       </div>

//       {/* Cards */}
//       <div className="card-section">
//         {getFilteredData().map((card) => (
//           <div
//             className="card"
//             key={card.id}
//             onClick={() => navigate(card.link)}
//           >
//             <img src={card.image} alt={card.title} />
//             <div className="card-content">
//               <p className="card-title">{card.title}</p>
//               {card.duration}
//               <p>{card.subtitle}</p>
//               <p className="price">{card.cost}</p>

//               <div className="card-footer">
//                 <p>{card.language}</p>
//                 <button className="know-btn">Know More</button>
//               </div>

//             </div>
//           </div>
//         ))}
//       </div>

//       <Advertisment />
//       <style jsx>{`
//         .filter-container {
//           display: flex;
//           gap: 20px;
//           padding: 20px;
//         }

//         .filter-title {
//           font-family: sans-serif;
//           font-size: 20px;
//           color: blue;
//           margin-top: 2px;
//         }

//         .sidebar {
//           min-width: 260px;
//           max-width: 366px;
//           position: sticky;
//           top: 172px;
//           background: #f9f9f9;
//           padding: 15px;
//           border-radius: 8px;
//           box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
//           height: fit-content;
//         }

//         .sidebar select {
//           width: 100%;
//           padding: 8px;
//           margin-bottom: 15px;
//           font-size: 15px;
//           border-radius: 5px;
//           border: 1px solid #ccc;
//         }

//         .card-section {
//           flex: 1;
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 20px;
//         }

//         .card {
//           background: #fff;
//           border: 1px solid #ddd;
//           height: 347px;
//           color: black;
//           overflow: hidden;
//           cursor: pointer;
//           transition: transform 0.2s ease;
//         }

//         .card:hover {
//           transform: translateY(-5px);
//         }

//         .card img {
//           width: 100%;
//           height: 160px;
//           object-fit: cover;
//           padding: 13px 5px 5px 5px;
//           border-radius: 20px;
//         }

//         .card-content {
//           padding: 10px;
//         }

//         .card-content p {
//           margin: 5px 0;
//           font-family: math;
//           gap: 5px;
//           color: black;
//         }

//         .card-title {
//           font-size: 20px;
//           color: blue;
//           font-family: roboto;
//         }

//         .price {
//           font-weight: bold;
//         }

//         .card-footer {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 15px; /* gap between language and button */
// }


//         .know-btn {
//   border-radius: 10px;
//   background-color: blue;
//   color: white;
//   padding: 5px 15px;
//   border: none;
//   cursor: pointer;
//   margin-left: 15px; /* gap from language text */
// }


//         /* Tablet */
//         @media (max-width: 992px) {
//           .card-section {
//             grid-template-columns: repeat(2, 1fr);
//           }
//         }

//         /* Mobile */
//         @media (max-width: 600px) {
//           .filter-container {
//             flex-direction: column;
//           }

//           .sidebar {
//             width: 100%;
//             position: relative;
//             top: auto;
//           }

//           .card-section {
//             grid-template-columns: 1fr;
//           }

//           .card {
//             width: 100%;
//           }
//         }
//       `}</style>



//       <div style={{ marginTop: '-314px', left: '-2px' }}>
//         <OnlyButtonrange />
//       </div>

//     </div>
//   );
// };

// export default BranchFilterComponent;




// import React, { useState } from 'react';
// import { useNavigate } from "react-router-dom";
// import mechImage from '../img/aaaservices/TOOL & FIXTURE V1.jpg';
// import itImage from '../img/aaaservices/PYTHON V1.jpg';
// import digitalImage from '../img/aaaservices/DIGITAL FACILITY SIMULATIONS V3.jpg';

// import mechImg from '../img/aaaservices/VR.webp';
// import simImg from '../img/aaaservices/slashco-bridle1-2.jpg';
// import itImg from '../img/aaaservices/Java-Full-Stack-1-600x367.jpg';
// import itImg1 from '../img/aaaservices/PY.jpg';
// import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';
// import dfsImg from '../img/aaaservices/F.png';
// import dfsImg1 from '../img/aaaservices/Thumbnail-Skill-Based-Professions-1.png';
// import dfsImg2 from '../img/aaaservices/s.png';
// import dfsImg3 from '../img/aaaservices/d.webp';
// import OnlyButtonrange from './OnlyButtonrange';
// import Advertisment from './Advertisment';

// const cardData = {
//   Mechanical: [
//   // Virtual Robotics - Basic
//   {
//     id: 1,
//     title: "Virtual Robotics - Basic",
//     subtitle: "Robotics Fundamentals & Automation",
//     date: "2025-06-01",
//     time: "10:00 AM - 4:00 PM",
//     cost: "₹14,999",
//     minPrice: 14999,
//     maxPrice: 14999,
//     duration: "2 Months",
//     location: "hyderabad",
//     language: "english",
//     image: mechImg,
//     link: "/Virtualpage",
//     level: "basic"
//   },

//   // Virtual Robotics - Advanced
//   {
//     id: 2,
//     title: "Virtual Robotics - Advanced",
//     subtitle: "Industrial Robotics & Programming",
//     date: "2025-06-05",
//     time: "11:00 AM - 5:00 PM",
//     cost: "₹29,999",
//     minPrice: 29999,
//     maxPrice: 29999,
//     duration: "3 Months",
//     location: "hyderabad",
//     language: "english",
//     image: mechImg,
//     link: "/Virtualpage",
//     level: "advanced"
//   },

//   // Virtual Robotics - Expert
//   {
//     id: 3,
//     title: "Virtual Robotics - Expert",
//     subtitle: "AI Robotics & Smart Factory Automation",
//     date: "2025-06-10",
//     time: "9:00 AM - 3:00 PM",
//     cost: "₹59,999",
//     minPrice: 59999,
//     maxPrice: 59999,
//     duration: "4Months",
//     location: "hyderabad",
//     language: "english",
//     image: mechImg,
//     link: "/Virtualpage",
//     level: "Expert"
//   },

//   // Tool & Fixture - Basic
//   {
//     id: 4,
//     title: "Tool & Fixture Design - Basic",
//     subtitle: "Fundamentals of Tool Design",
//     date: "2025-06-15",
//     time: "10:00 AM - 4:00 PM",
//     cost: "₹14,999",
//     minPrice: 14999,
//     maxPrice: 14999,
//     duration: "2 Months",
//     location: "hyderabad",
//     language: "english",
//     image: simImg,
//     link: "/fixture",
//     level: "basic"
//   },

//   // Tool & Fixture - Advanced
//   {
//     id: 5,
//     title: "Tool & Fixture Design - Advanced",
//     subtitle: "Industrial Tool & Fixture Development",
//     date: "2025-06-20",
//     time: "11:00 AM - 5:00 PM",
//     cost: "₹29,999",
//     minPrice: 29999,
//     maxPrice: 29999,
//     duration: "3 Months",
//     location: "hyderabad",
//     language: "english",
//     image: simImg,
//     link: "/fixture",
//     level: "advanced"
//   },

//   // Tool & Fixture - Expert
//   {
//     id: 6,
//     title: "Tool & Fixture Design - Expert",
//     subtitle: "Master Tooling & Manufacturing Solutions",
//     date: "2025-06-25",
//     time: "9:00 AM - 3:00 PM",
//     cost: "₹59,999",
//     minPrice: 59999,
//     maxPrice: 59999,
//     duration: "4Months",
//     location: "hyderabad",
//     language: "english",
//     image: simImg,
//     link: "/fixture",
//     level: "Expert"
//   },

//   // Digital Factory - Basic
//   {
//     id: 7,
//     title: "Digital Factory - Basic",
//     subtitle: "Smart Manufacturing Fundamentals",
//     date: "2025-07-01",
//     time: "10:00 AM - 4:00 PM",
//     cost: "₹14,999",
//     minPrice: 14999,
//     maxPrice: 14999,
//     duration: "2 Months",
//     location: "hyderabad",
//     language: "english",
//     image: dfsImg,
//     link: "/DigitalC",
//     level: "basic"
//   },

//   // Digital Factory - Advanced
//   {
//     id: 8,
//     title: "Digital Factory - Advanced",
//     subtitle: "Industry 4.0 & Factory Simulation",
//     date: "2025-07-05",
//     time: "11:00 AM - 5:00 PM",
//     cost: "₹29,999",
//     minPrice: 29999,
//     maxPrice: 29999,
//     duration: "3 Months",
//     location: "hyderabad",
//     language: "english",
//     image: dfsImg,
//     link: "/DigitalC",
//     level: "advanced"
//   },

//   // Digital Factory - Expert
//   {
//     id: 9,
//     title: "Digital Factory - Expert",
//     subtitle: "AI Powered Smart Factory & Automation",
//     date: "2025-07-10",
//     time: "9:00 AM - 3:00 PM",
//     cost: "₹59,999",
//     minPrice: 59999,
//     maxPrice: 59999,
//     duration: "4Months",
//     location: "hyderabad",
//     language: "english",
//     image: dfsImg,
//     link: "/DigitalC",
//     level: "Expert"
//   }
// ],
//   IT: [
//     // Basic (Individual technologies) - 2 Months
//     { id: 10, title: "Java Programming", subtitle: "Core Java Basics", date: "2025-06-17", time: "1:00 PM - 6:00 PM", cost: "₹14,999", minPrice: 14999, maxPrice: 14999, duration: "2 Months", location: "hyderabad", language: "english, ", image: itImg, link: "/it-services", level: "basic" },
//     { id: 11, title: "Python Programming", subtitle: "Python Fundamentals", date: "2025-06-19", time: "10:00 AM - 2:00 PM", cost: "₹14,999", minPrice: 14999, maxPrice: 14999, duration: "2 Months", location: "hyderabad", language: "english, ", image: itImg1, link: "/Puthonpage", level: "basic" },
//     { id: 12, title: "React Development", subtitle: "Frontend Framework", date: "2025-06-19", time: "10:00 AM - 2:00 PM", cost: "₹14,999", minPrice: 14999, maxPrice: 14999, duration: "2 Months", location: "hyderabad", language: "english, ", image: itImg2, link: "/Reactpage", level: "basic" },
//     { id: 13, title: "Flutter Development", subtitle: "Cross-Platform Apps", date: "2025-06-19", time: "10:00 AM - 2:00 PM", cost: "₹14,999", minPrice: 14999, maxPrice: 14999, duration: "2 Months", location: "hyderabad", language: "english, ", image: itImg2, link: "/Reactpage", level: "basic" },
//     // Advanced - 3 Months
//     { id: 14, title: "Spring Boot & MySQL", subtitle: "Backend Development", date: "2025-06-20", time: "11:00 AM - 4:00 PM", cost: "₹29,999", minPrice: 29999, maxPrice: 29999, duration: "3 Months", location: "hyderabad", language: "english, ", image: itImg1, link: "/springboot", level: "advanced" },
//     // Expert (Full Stack) - 4Months
//     { id: 15, title: "Java Full Stack", subtitle: "Complete Stack Developer", date: "2025-06-21", time: "9:00 AM - 5:00 PM", cost: "₹59,999", minPrice: 59999, maxPrice: 59999, duration: "4Months", location: "hyderabad", language: "english, ", image: itImg, link: "/javafullstack", level: "Expert" },
//     { id: 16, title: "Python Full Stack", subtitle: "Complete Stack Developer", date: "2025-06-22", time: "9:00 AM - 5:00 PM", cost: "₹59,999", minPrice: 59999, maxPrice: 59999, duration: "4Months", location: "hyderabad", language: "english, ", image: itImg1, link: "/pythonfullstack", level: "Expert" },
//     { id: 17, title: "HTML, CSS & JavaScript", subtitle: "Complete Web Fundamentals", date: "2025-06-18", time: "10:00 AM - 3:00 PM", cost: "₹29,999", minPrice: 29999, maxPrice: 29999, duration: "3 Months", location: "hyderabad", language: "english, ", image: itImg2, link: "/web-fundamentals", level: "advanced" },
//   ],
//   // Digital: [
//   //   // Basic - 2 Months
//   //   { id: 11, title: "Career Foundation Skills", subtitle: "Professional Basics", date: "2025-06-21", time: "10:00 AM - 4:00 PM", cost: "₹14,999", minPrice: 14999, maxPrice: 14999, duration: "2 Months", location: "hyderabad", language: "english, ", image: dfsImg1, link: "/Outdoor", level: "basic" },
//   //   // Advanced - 3 Months
//   //   { id: 12, title: "Soft Skill Enhancements", subtitle: "Communication Mastery", date: "2025-06-22", time: "9:00 AM - 1:00 PM", cost: "₹29,999", minPrice: 29999, maxPrice: 29999, duration: "3 Months", location: "hyderabad", language: "english, ", image: dfsImg2, link: "/Sopftskillpage", level: "advanced" },
//   //   // Expert - 4Months
//   //   { id: 13, title: "Digital Presence Skills", subtitle: "Online Branding Pro", date: "2025-06-22", time: "9:00 AM - 1:00 PM", cost: "₹59,999", minPrice: 59999, maxPrice: 59999, duration: "4Months", location: "hyderabad", language: "english, ", image: dfsImg3, link: "/Digitalpresenceskillpage", level: "Expert" },
//   // ]
// };

// const BranchFilterComponent = () => {
//   const navigate = useNavigate();

//   const [selectedBranch, setSelectedBranch] = useState("All");
//   const [calendarDate, setCalendarDate] = useState("");
//   const [location, setLocation] = useState("");
//   const [language, setLanguage] = useState("");
//   const [minPrice, setMinPrice] = useState("");
//   const [maxPrice, setMaxPrice] = useState("");
//   const [selectedLevel, setSelectedLevel] = useState("All");

//   const getFilteredData = () => {
//     let data =
//       selectedBranch === "All"
//         ? [...cardData.Mechanical, ...cardData.IT, ]
//         : cardData[selectedBranch] || [];

//     if (calendarDate) {
//       data = data.filter((card) => card.date === calendarDate);
//     }

//     if (location) {
//       data = data.filter((card) => card.location === location);
//     }

//     if (language) {
//       data = data.filter((card) =>
//         card.language.toLowerCase().includes(language.toLowerCase())
//       );
//     }

//     if (minPrice !== "" || maxPrice !== "") {
//       const min = minPrice ? parseInt(minPrice) : 0;
//       const max = maxPrice ? parseInt(maxPrice) : Infinity;

//       data = data.filter((card) => {
//         const price = card.minPrice;
//         return price >= min && price <= max;
//       });
//     }

//     if (selectedLevel !== "All") {
//       data = data.filter((card) => card.level === selectedLevel);
//     }

//     return data;
//   };

//   return (
//     <div className="filter-container">
//       {/* Sidebar */}
//       <div className="sidebar">
//         <h3 className="filter-title">Filters</h3>

//         <select
//           value={selectedBranch}
//           onChange={(e) => setSelectedBranch(e.target.value)}
//         >
//           <option value="All">All Branches</option>
//           <option value="Mechanical">Mechanical</option>
//           <option value="IT">IT</option>
//           {/* <option value="Digital">Digital</option> */}
//         </select>

//         {/* Level Filter */}
//         {/* <select
//           value={selectedLevel}
//           onChange={(e) => setSelectedLevel(e.target.value)}
//         >
//           <option value="All">All Levels</option>
//           <option value="basic">Basic (₹14,999 - 2 Months)</option>
//           <option value="advanced">Advanced (₹29,999 - 3 Months)</option>
//           <option value="Expert">Expert (₹59,999 - 4Months)</option>
//         </select> */}

//         <select value={location} onChange={(e) => setLocation(e.target.value)}>
//           <option value="">Location</option>
//           <option value="hyderabad">Hyderabad</option>
//         </select>

//         <select value={language} onChange={(e) => setLanguage(e.target.value)}>
//           <option value="">Language</option>
//           <option value="english">English</option>
//         </select>

//         <select value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)}>
//           <option value="">Max Price</option>
//           <option value="14999">₹14,999</option>
//           <option value="29999">₹29,999</option>
//           <option value="59999">₹59,999</option>
//         </select>
        
//         <select disabled>
//           <option value="">Duration: Varies (2-4Months)</option>
//         </select>
//       </div>

//       {/* Cards */}
//       <div className="card-section">
//         {getFilteredData().map((card) => (
//           <div
//             className="card"
//             key={card.id}
//             onClick={() => navigate(card.link)}
//           >
//             <img src={card.image} alt={card.title} />
//             <div className="card-content">
//               <p className="card-title">{card.title}</p>
//               <p className="card-duration" style={{ color: '#666', fontSize: '14px' }}>{card.duration}</p>
//               <p>{card.subtitle}</p>
//               <p className="price">{card.cost}</p>

//               <div className="card-footer">
//                 <p>{card.language}</p>
//                 <button className="know-btn">Know More</button>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* <Advertisment /> */}
      
//       <style jsx>{`
//         .filter-container {
//           display: flex;
//           gap: 20px;
//           padding: 20px;
//         }

//         .filter-title {
//           font-family: sans-serif;
//           font-size: 20px;
//           color: blue;
//           margin-top: 2px;
//         }

//         .sidebar {
//           min-width: 260px;
//           max-width: 366px;
//           position: sticky;
//           top: 172px;
//           background: #f9f9f9;
//           padding: 15px;
//           border-radius: 8px;
//           box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
//           height: fit-content;
//         }

//         .sidebar select {
//           width: 100%;
//           padding: 8px;
//           margin-bottom: 15px;
//           font-size: 15px;
//           border-radius: 5px;
//           border: 1px solid #ccc;
//         }

//         .card-section {
//           flex: 1;
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 20px;
//         }

//         .card {
//           background: #fff;
//           border: 1px solid #ddd;
//           height: 360px;
//           color: black;
//           overflow: hidden;
//           cursor: pointer;
//           transition: transform 0.2s ease;
//         }

//         .card:hover {
//           transform: translateY(-5px);
//         }

//         .card img {
//           width: 100%;
//           height: 160px;
//           object-fit: cover;
//           padding: 13px 5px 5px 5px;
//           border-radius: 20px;
//         }

//         .card-content {
//           padding: 10px;
//         }

//         .card-content p {
//           margin: 5px 0;
//           font-family: math;
//           gap: 5px;
//           color: black;
//         }

//         .card-title {
//           font-size: 18px;
//           color: blue;
//           font-family: roboto;
//           font-weight: bold;
//         }

//         .price {
//           font-weight: bold;
//           color: #e67e22;
//           font-size: 16px;
//         }

//         .card-footer {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           gap: 15px;
//           margin-top: 5px;
//         }

//         .know-btn {
//           border-radius: 10px;
//           background-color: blue;
//           color: white;
//           padding: 5px 15px;
//           border: none;
//           cursor: pointer;
//           margin-left: 15px;
//         }

//         /* Tablet */
//         @media (max-width: 992px) {
//           .card-section {
//             grid-template-columns: repeat(2, 1fr);
//           }
//         }

//         /* Mobile */
//         @media (max-width: 600px) {
//           .filter-container {
//             flex-direction: column;
//           }

//           .sidebar {
//             width: 100%;
//             position: relative;
//             top: auto;
//           }

//           .card-section {
//             grid-template-columns: 1fr;
//           }

//           .card {
//             width: 100%;
//           }
//         }
//       `}</style>

//       <div style={{ marginTop: '-314px', left: '-2px' }}>
//         <OnlyButtonrange />
//       </div>
//     </div>
//   );
// };

// export default BranchFilterComponent;
 





import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import './Newprogram.css'; // Separate CSS file

import mechImg from '../img/aaaservices/VR.webp';
import simImg from '../img/aaaservices/slashco-bridle1-2.jpg';
import itImg from '../img/aaaservices/Java-Full-Stack-1-600x367.jpg';
import itImg1 from '../img/aaaservices/PY.jpg';
import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';
import dfsImg from '../img/aaaservices/F.png';
import OnlyButtonrange from './OnlyButtonrange';

const cardData = {
  Mechanical: [
    {
      id: 1,
      title: "Virtual Robotics - Basic",
      subtitle: "Robotics Fundamentals & Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
      location: "hyderabad",
      language: "english",
      image: mechImg,
      link: "/Virtualpage",
      level: "basic"
    },
    {
      id: 2,
      title: "Virtual Robotics - Advanced",
      subtitle: "Industrial Robotics & Programming",
      date: "2025-06-05",
      time: "11:00 AM - 5:00 PM",
      cost: "₹29,999",
      minPrice: 29999,
      maxPrice: 29999,
      duration: "3 Months",
      location: "hyderabad",
      language: "english",
      image: mechImg,
      link: "/Virtualpage",
      level: "advanced"
    },
    {
      id: 3,
      title: "Virtual Robotics - Expert",
      subtitle: "AI Robotics & Smart Factory Automation",
      date: "2025-06-10",
      time: "9:00 AM - 3:00 PM",
      cost: "₹59,999",
      minPrice: 59999,
      maxPrice: 59999,
      duration: "4Months",
      location: "hyderabad",
      language: "english",
      image: mechImg,
      link: "/Virtualpage",
      level: "Expert"
    },
    {
      id: 4,
      title: "Tool & Fixture Design - Basic",
      subtitle: "Fundamentals of Tool Design",
      date: "2025-06-15",
      time: "10:00 AM - 4:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
      location: "hyderabad",
      language: "english",
      image: simImg,
      link: "/fixture",
      level: "basic"
    },
    {
      id: 5,
      title: "Tool & Fixture Design - Advanced",
      subtitle: "Industrial Tool & Fixture Development",
      date: "2025-06-20",
      time: "11:00 AM - 5:00 PM",
      cost: "₹29,999",
      minPrice: 29999,
      maxPrice: 29999,
      duration: "3 Months",
      location: "hyderabad",
      language: "english",
      image: simImg,
      link: "/fixture",
      level: "advanced"
    },
    {
      id: 6,
      title: "Tool & Fixture Design - Expert",
      subtitle: "Master Tooling & Manufacturing Solutions",
      date: "2025-06-25",
      time: "9:00 AM - 3:00 PM",
      cost: "₹59,999",
      minPrice: 59999,
      maxPrice: 59999,
      duration: "4Months",
      location: "hyderabad",
      language: "english",
      image: simImg,
      link: "/fixture",
      level: "Expert"
    },
    {
      id: 7,
      title: "Digital Factory - Basic",
      subtitle: "Smart Manufacturing Fundamentals",
      date: "2025-07-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
      location: "hyderabad",
      language: "english",
      image: dfsImg,
      link: "/DigitalC",
      level: "basic"
    },
    {
      id: 8,
      title: "Digital Factory - Advanced",
      subtitle: "Industry 4.0 & Factory Simulation",
      date: "2025-07-05",
      time: "11:00 AM - 5:00 PM",
      cost: "₹29,999",
      minPrice: 29999,
      maxPrice: 29999,
      duration: "3 Months",
      location: "hyderabad",
      language: "english",
      image: dfsImg,
      link: "/DigitalC",
      level: "advanced"
    },
    {
      id: 9,
      title: "Digital Factory - Expert",
      subtitle: "AI Powered Smart Factory & Automation",
      date: "2025-07-10",
      time: "9:00 AM - 3:00 PM",
      cost: "₹59,999",
      minPrice: 59999,
      maxPrice: 59999,
      duration: "4Months",
      location: "hyderabad",
      language: "english",
      image: dfsImg,
      link: "/DigitalC",
      level: "Expert"
    }
  ],
  IT: [
  // Java Track
  {
    id: 10,
    title: "Java Programming",
    subtitle: "Core Java Basics",
    date: "2025-06-17",
    time: "1:00 PM - 6:00 PM",
    cost: "₹14,999",
    minPrice: 14999,
    maxPrice: 14999,
    duration: "2 Months",
    location: "hyderabad",
    language: "english",
    image: itImg,
    link: "/it-services",
    level: "basic"
  },
  {
    id: 11,
    title: "Advanced Java Programming",
    subtitle: "Collections, JDBC & OOPs",
    date: "2025-06-19",
    time: "10:00 AM - 2:00 PM",
    cost: "₹29,999",
    minPrice: 29999,
    maxPrice: 29999,
    duration: "3 Months",
    location: "hyderabad",
    language: "english",
    image: itImg,
    link: "/it-services",
    level: "advanced"
  },
  {
    id: 12,
    title: "Java Full Stack",
    subtitle: "Complete Stack Developer",
    date: "2025-06-21",
    time: "9:00 AM - 5:00 PM",
    cost: "₹59,999",
    minPrice: 59999,
    maxPrice: 59999,
    duration: "4Months",
    location: "hyderabad",
    language: "english",
    image: itImg,
    link: "/it-services",
    level: "expert"
  },

  // Python Track
  {
    id: 13,
    title: "Python Programming",
    subtitle: "Python Fundamentals",
    date: "2025-06-22",
    time: "10:00 AM - 2:00 PM",
    cost: "₹14,999",
    minPrice: 14999,
    maxPrice: 14999,
    duration: "2 Months",
    location: "hyderabad",
    language: "english",
    image: itImg1,
    link: "/Puthonpage",
    level: "basic"
  },
  {
    id: 14,
    title: "Advanced Python Programming",
    subtitle: "Django, APIs & Automation",
    date: "2025-06-24",
    time: "11:00 AM - 4:00 PM",
    cost: "₹29,999",
    minPrice: 29999,
    maxPrice: 29999,
    duration: "3 Months",
    location: "hyderabad",
    language: "english",
    image: itImg1,
    link: "/Puthonpage",
    level: "advanced"
  },
  {
    id: 15,
    title: "Python Full Stack",
    subtitle: "Complete Stack Developer",
    date: "2025-06-26",
    time: "9:00 AM - 5:00 PM",
    cost: "₹59,999",
    minPrice: 59999,
    maxPrice: 59999,
    duration: "4Months",
    location: "hyderabad",
    language: "english",
    image: itImg1,
    link: "/Puthonpage",
    level: "expert"
  },

  // React Only
  {
    id: 16,
    title: "React Development",
    subtitle: "Frontend Framework",
    date: "2025-06-28",
    time: "10:00 AM - 2:00 PM",
    cost: "₹14,999",
    minPrice: 14999,
    maxPrice: 14999,
    duration: "2 Months",
    location: "hyderabad",
    language: "english",
    image: itImg2,
    link: "/Reactpage",
    level: "basic"
  },

  // Flutter Only
  {
    id: 17,
    title: "Flutter Development",
    subtitle: "Cross-Platform Apps",
    date: "2025-06-29",
    time: "10:00 AM - 2:00 PM",
    cost: "₹14,999",
    minPrice: 14999,
    maxPrice: 14999,
    duration: "2 Months",
    location: "hyderabad",
    language: "english",
    image: itImg2,
    link: "/Flutterpage",
    level: "basic"
  },

  // Spring Boot & MySQL
  {
    id: 18,
    title: "Spring Boot & MySQL",
    subtitle: "Backend Development",
    date: "2025-06-30",
    time: "11:00 AM - 4:00 PM",
    cost: "₹29,999",
    minPrice: 29999,
    maxPrice: 29999,
    duration: "3 Months",
    location: "hyderabad",
    language: "english",
    image: itImg1,
    link: "/Springbootpage",
    level: "advanced"
  },

  // HTML CSS JavaScript
  {
    id: 19,
    title: "HTML, CSS & JavaScript",
    subtitle: "Complete Web Fundamentals",
    date: "2025-07-01",
    time: "10:00 AM - 3:00 PM",
    cost: "₹14,999",
    minPrice: 14999,
    maxPrice: 14999,
    duration: "2 Months",
    location: "hyderabad",
    language: "english",
    image: itImg2,
    link: "/Htmlpage",
    level: "basic"
  }
]
};

const BranchFilterComponent = () => {
  const navigate = useNavigate();

  const [selectedBranch, setSelectedBranch] = useState("All");
  const [location, setLocation] = useState("");
  const [language, setLanguage] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("All");

  const getFilteredData = () => {
    let data =
      selectedBranch === "All"
        ? [...cardData.Mechanical, ...cardData.IT]
        : cardData[selectedBranch] || [];

    if (location) {
      data = data.filter((card) => card.location === location);
    }

    if (language) {
      data = data.filter((card) =>
        card.language.toLowerCase().includes(language.toLowerCase())
      );
    }

    if (maxPrice !== "") {
      const max = parseInt(maxPrice);
      data = data.filter((card) => card.minPrice <= max);
    }

    if (selectedLevel !== "All") {
      data = data.filter((card) => card.level === selectedLevel);
    }

    return data;
  };

  return (
    <div className="course-container">
      {/* Fixed Sidebar */}
      <div className="course-sidebar">
        <h3 className="course-sidebar-title">Filters</h3>

        <select
          className="course-select"
          value={selectedBranch}
          onChange={(e) => setSelectedBranch(e.target.value)}
        >
          <option value="All">All Branches</option>
          <option value="Mechanical">Mechanical</option>
          <option value="IT">IT</option>
        </select>

        <select
          className="course-select"
          value={selectedLevel}
          onChange={(e) => setSelectedLevel(e.target.value)}
        >
          <option value="All">All Levels</option>
          <option value="basic">Basic (₹14,999 - 2 Months)</option>
          <option value="advanced">Advanced (₹29,999 - 3 Months)</option>
          <option value="Expert">Expert (₹59,999 - 4Months)</option>
        </select>

        <select className="course-select" value={location} onChange={(e) => setLocation(e.target.value)}>
          <option value="">Location</option>
          <option value="hyderabad">Hyderabad</option>
        </select>

        <select className="course-select" value={language} onChange={(e) => setLanguage(e.target.value)}>
          <option value="">Language</option>
          <option value="english">English</option>
        </select>

        <select className="course-select" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)}>
          <option value="">Max Price</option>
          <option value="14999">₹14,999</option>
          <option value="29999">₹29,999</option>
          <option value="59999">₹59,999</option>
        </select>
        
        <select className="course-select" disabled>
          <option value="">Duration: Varies (2-4Months)</option>
        </select>
      </div>

      {/* Cards Section - 4 Cards per row */}
      <div className="course-main-content">
        <div className="course-grid">
          {getFilteredData().map((card) => (
            <div
              className="course-card"
              key={card.id}
              onClick={() => navigate(card.link)}
            >
              <img className="course-card-image" src={card.image} alt={card.title} />
              <div className="course-card-content">
                <p className="course-card-title">{card.title}</p>
                <p className="course-card-duration">{card.duration}</p>
                <p className="course-card-subtitle">{card.subtitle}</p>
                <p className="course-card-price">{card.cost}</p>
                <div className="course-card-footer">
                  <p className="course-card-language">{card.language}</p>
                  <button className="course-card-button">Know More</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* <div className="course-button-range">
        <OnlyButtonrange />
      </div> */}
    </div>
  );
};

export default BranchFilterComponent;